module.exports = __webpack_public_path__ + "img/operator_horn.e4adcd6b.svg";